import { createModel } from '@rematch/core';
import { AppConfig } from '../../models/app-config';

export interface State {
    appConfig: Undefinable<AppConfig>;
    menuState: boolean;
}

export const appStates = createModel<State>({
    state: {
        menuState: false,
    },
    reducers: {
        setAppConfig: (
            state: State,
            data: Undefinable<AppConfig>
        ): State => ({
            ...state,
            appConfig: data
        }),
        toggleMenuState: (
            state: State,
            data?: boolean
        ): State => ({
            ...state,
            menuState: data === undefined ? !state.menuState : data
        })
    }
});
